import fonts from './fonts'

import arrow_option_left from 'public/assets/svg/arrows/arrow_option_left.raw.svg'
import arrow_option_right from 'public/assets/svg/arrows/arrow_option_right.raw.svg'
import arrow_forward from 'public/assets/svg/arrows/arrow_forward.raw.svg'
import arrow_forward_turn_around from 'public/assets/svg/arrows/arrow_forward_turn_around.raw.svg'
import arrow_forward_turn_left from 'public/assets/svg/arrows/arrow_forward_turn_left.raw.svg'
import arrow_forward_turn_right from 'public/assets/svg/arrows/arrow_forward_turn_right.raw.svg'
import arrow_forward_bair_left from 'public/assets/svg/arrows/arrow_forward_bair_left.raw.svg'
import arrow_forward_bair_right from 'public/assets/svg/arrows/arrow_forward_bair_right.raw.svg'

//All back arrows will point backwards for now
import arrow_back from 'public/assets/svg/arrows/arrow_back.raw.svg'

//TODO: these files need to have their path resolved properly, currently it points to assets which are staticly hosted in teh yv_website repo
const navigation_hint_left = '/Assets/svg/navigation_hints/navigation_hint_left.png'
const navigation_hint_right = '/Assets/svg/navigation_hints/navigation_hint_right.png'

//All back arrows will point backwards for now
const backNav = {
    B: {
        width: '2.6em',
        height: '1.7em',
    },
}

const look = {
    width: '8.95em',
    height: '8.475em',
    color: '#fff',
    textAlign: 'center',
    backgroundColor: 'rgba(37, 46, 64, .8)',
    borderRadius: 10,
    fontSize: 14,
    fontWeight: 'lighter',
}

const nav_hint = Object.assign(
    {},
    {
        position: 'relative',
        width: '8.85em',
        height: '6.75em',
        margin: '0.1em 0.25em',
    }
)
const nav_hint_label = {
    cursor: 'pointer',
    width: '65%',
    height: '65%',
    color: '#fff',
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    textShadow: '0 2px 4px rgba(0, 0, 0, 0.5)',
    fontSize: 21,
}

const nav_hint_arrow = Object.assign(
    {},
    {
        position: 'absolute',
        top: '50%',
        width: '0.95em',
        height: '0.55em',
    }
)

const nav_hint_forward = Object.assign({}, nav_hint, {
    width: '9.5em',
    height: '3.6em',
    margin: 'auto',
    padding: '0 0.5rem',
    backgroundColor: 'rgba(37, 46, 64, .8)',
    boxShadow: '0 0.2em 0.45em 0 rgba(0, 0, 0, 0.5)',
    borderRadius: 8.8,
    left: 0,
    right: 0,
    bottom: 40,
    overflow: 'hidden',
    WebkitLineClamp: '2',
    textOverflow: 'ellipsis',
})

const nav_hint_forward_single = Object.assign({}, nav_hint_forward, {
    bottom: 20,
})

const nav_hint_label_forward = Object.assign({}, nav_hint_label, {
    display: 'inline-block',
    width: 'auto',
    position: 'relative',
    top: 'auto',
    textAlign: 'center',
    transform: 'none',
    fontSize: 16,
})
export default {
    arrow: {
        F: {
            width: '2.25em',
            height: '3.45em',
        },
        F_B: {
            width: '4.9em',
            height: '3.8em',
        },
        F_L: {
            width: '4.4em',
            height: '3em',
        },
        F_R: {
            width: '4.5em',
            height: '3.05em',
        },
        F_BL: {
            width: '3.45em',
            height: '3.55em',
        },
        F_BR: {
            width: '3.45em',
            height: '3.5em',
        },
        B: backNav.B,
        B_F: backNav.B,
        B_L: backNav.B,
        B_R: backNav.B,
        B_BL: backNav.B,
        B_BR: backNav.B,
        L: {
            width: '4.85em',
            height: '1.95em',
        },
        R: {
            width: '4.85em',
            height: '1.95em',
        },
    },
    hint: {
        LEFT: nav_hint,
        RIGHT: nav_hint,
        FRONT: nav_hint_forward,
        FRONT_SINGLE: nav_hint_forward_single,
    },
    hint_label: {
        LEFT: Object.assign({}, nav_hint_label, {
            textAlign: 'right',
            right: '10%',
        }),
        RIGHT: Object.assign({}, nav_hint_label, {
            left: '14%',
        }),
        FRONT: Object.assign({}, nav_hint_label_forward, {
            width: '100%',
            height: '100%',
        }),
    },
    hint_arrow: {
        LEFT: Object.assign({}, nav_hint_arrow, {
            left: '5%',
            transform: 'translateY(-50%) rotateZ(90deg)',
        }),
        RIGHT: Object.assign({}, nav_hint_arrow, {
            right: '8%',
            transform: 'translateY(-50%) rotateZ(-90deg)',
        }),
        FRONT: Object.assign(
            {},
            {
                display: 'none',
            }
        ),
    },
    svg: {
        arrows: {
            L: arrow_option_left,
            R: arrow_option_right,
            F: arrow_forward,
            F_B: arrow_forward_turn_around,
            F_L: arrow_forward_turn_left,
            F_R: arrow_forward_turn_right,
            F_BL: arrow_forward_bair_left,
            F_BR: arrow_forward_bair_right,
            B: arrow_back,
            B_F: arrow_back,
            B_L: arrow_back,
            B_R: arrow_back,
            B_BL: arrow_back,
            B_BR: arrow_back,
        },
        hints: {
            LEFT: navigation_hint_left,
            RIGHT: navigation_hint_right,
        },
    },
    look: {
        RIGHT: look,
        LEFT: look,
    },
}
